var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupSoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 8 1-6h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupSoda);
export default __webpack_public_path__ + "static/media/cup-soda.1d206f106816a0817ede1528836ea74e.svg";
export { ForwardRef as ReactComponent };